module.exports = __webpack_public_path__ + "img/passed.47ff14da.svg";